import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';

const ProgressBar = () => {
    const [progress, setProgress] = useState(0);
    const [statusMessage, setStatusMessage] = useState("Оновлення не розпочато");

    const SERVER_URL = process.env.NODE_ENV === "production"
        ? "https://aqueous-atoll-11213.herokuapp.com"
        : "http://localhost:5001";


    useEffect(() => {
        const socket = io(SERVER_URL);

        socket.on("progress_update", (data) => {
            if (data.status === 'in-progress') {
                setStatusMessage(data.message);
            } else if (data.status === 'completed') {
                setStatusMessage("Оновлення завершено!");
            }
        });

        return () => {
            socket.disconnect();
        };
    }, []);

    return (
        <div>
            <p>{statusMessage}</p>
            {/* прогрес */}
        </div>
    );
};

export default ProgressBar;
